export default "__VITE_ASSET__6Lfed76k__"